export const isObject = (object: unknown): object is Record<string, unknown> =>
  typeof object === 'object' && object !== null && !Array.isArray(object)

export const definedProps = <T>(obj: Record<string, T>): Record<string, T> =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== undefined && v !== null),
  )
